<script lang="ts">
	import type { SelectUser, SelectUserDetail } from '$db/tables';
	import { slide } from 'svelte/transition';

	interface Props {
		user: (SelectUser & { userDetails: SelectUserDetail | null }) | undefined;
	}

	let { user }: Props = $props();
</script>

{#if user && user.userDetails && Object.keys(user.userDetails).some((key) => {
		if (key !== 'sportSpassNumber') {
			// @ts-expect-error
			return user.userDetails[key as keyof typeof user.userDetails] === null;
		}
	})}
	<div class="w-full bg-foreground" transition:slide>
		<div class="container mx-auto py-1.5">
			<p class="text-center text-sm text-background">
				Bitte
				<a href="/account" class="font-medium underline">gebe fehlende Information an</a>, um nach
				Kursabschluss deine Urkunde zu erhalten.
			</p>
		</div>
	</div>
{/if}
